import { BACKSPACE_KEY } from '../../../const/keyNames';
export const handleOnChange = (event, values, inputRefs, numberOfFields, type, triggerChange) => {
    const index = parseInt(event.target.dataset.id || '0', 10);
    const targetValue = type === 'tel'
        ? event.target.value.replace(/[^\d]/gi, '')
        : event.target.value;
    if (targetValue === '')
        return;
    const newValues = [...values];
    const nextIndex = targetValue.length + index;
    const lastIndex = numberOfFields - 1;
    const nextRef = nextIndex >= numberOfFields ? inputRefs[lastIndex] : inputRefs[nextIndex];
    nextRef.current.focus();
    targetValue.split('').forEach((item, i) => {
        const cursor = index + i;
        if (cursor < numberOfFields) {
            newValues[cursor] = item;
        }
    });
    triggerChange(newValues);
};
export const handleBackspace = (event, values, triggerChange, inputRefs) => {
    if (event.key !== BACKSPACE_KEY)
        return;
    const index = parseInt(event.target.dataset.id || '0', 10);
    const prevRef = inputRefs[index - 1];
    event.preventDefault();
    const newValues = [...values];
    if (values[index]) {
        newValues[index] = '';
    }
    else if (prevRef) {
        newValues[index - 1] = '';
        prevRef.current.focus();
    }
    triggerChange(newValues);
};
